import { render } from "./defaultSuggestions.vue?vue&type=template&id=a39d108c"
import script from "./defaultSuggestions.vue?vue&type=script&lang=js"
export * from "./defaultSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__